if (!customElements.get("accordion-wrapper")) {
  let accordionInstanceCount = 0;

  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.items = this.querySelectorAll(".td-accordion__item");
      this.onlyOneActive = false;
      this.instanceId = this.id || `td-accordion-${accordionInstanceCount += 1}`;
      this.boundOnLoad = this.bindEvents.bind(this);
    }

    connectedCallback() {
      if (document.readyState === "complete") {
        this.bindEvents();
      } else {
        window.addEventListener("load", this.boundOnLoad, { once: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener("load", this.boundOnLoad);
    }

    bindEvents() {
      const el = this;
      this.items = this.querySelectorAll(".td-accordion__item");

      this.items.forEach(function (item, index) {
        const toggle = item.querySelector(".td-accordion__toggle");
        const content = item.querySelector(".td-accordion__content");
        const itemId = item.dataset.item || index;
        const toggleId = `${el.instanceId}-toggle-${itemId}`;
        const contentId = `${el.instanceId}-content-${itemId}`;
        const isActive = item.classList.contains("is-active");

        if (toggle) {
          toggle.id = toggleId;

          if (toggle.tagName !== "BUTTON") {
            toggle.setAttribute("role", "button");
            toggle.setAttribute("tabindex", "0");
          } else {
            toggle.type = "button";
          }

          if (!toggle.dataset.accordionBound) {
            toggle.addEventListener("click", function (event) {
              event.preventDefault();
              el.toggle(item.dataset.item);
            });
            toggle.addEventListener("keydown", function (event) {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                el.toggle(item.dataset.item);
              }
            });
            toggle.dataset.accordionBound = "true";
          }

          if (content) {
            toggle.setAttribute("aria-controls", contentId);
            toggle.setAttribute("aria-expanded", isActive ? "true" : "false");
          }

          if (item.dataset.open && !item.dataset.autoOpened) {
            item.dataset.autoOpened = "true";
            setTimeout(function () {
              el.toggle(item.dataset.item);
            }, 1000);
          }
        }

        if (content) {
          content.id = contentId;
          content.setAttribute("role", "region");
          if (toggle) {
            content.setAttribute("aria-labelledby", toggleId);
          }

          if (isActive) {
            content.hidden = false;
            content.style.maxHeight = content.scrollHeight + "px";
          } else {
            content.hidden = true;
            content.style.maxHeight = null;
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext && !toggleNext.dataset.accordionBound) {
          if (toggleNext.tagName !== "BUTTON") {
            toggleNext.setAttribute("role", "button");
            toggleNext.setAttribute("tabindex", "0");
          } else {
            toggleNext.type = "button";
          }

          const handleNext = function (event) {
            event.preventDefault();
            el.toggle(parseInt(item.dataset.item, 10) + 1);
          };

          toggleNext.addEventListener("click", handleNext);
          toggleNext.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
              handleNext(event);
            }
          });
          toggleNext.dataset.accordionBound = "true";
        }
      });
    }

    setItemState(item, isActive) {
      const toggle = item.querySelector(".td-accordion__toggle");
      const content = item.querySelector(".td-accordion__content");
      if (!content) return;

      if (content.hideTimer) {
        clearTimeout(content.hideTimer);
      }

      item.classList.toggle("is-active", isActive);
      toggle?.setAttribute("aria-expanded", isActive ? "true" : "false");

      if (isActive) {
        content.hidden = false;
        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + "px";
        });
        return;
      }

      content.style.maxHeight = null;
      content.hideTimer = window.setTimeout(() => {
        if (!item.classList.contains("is-active")) {
          content.hidden = true;
        }
      }, 500);
    }

    toggle(currentItem) {
      const el = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".td-accordion__content");
        if (!content) return;

        if (item.dataset.item == currentItem) {
          el.setItemState(item, !item.classList.contains("is-active"));
        } else if (el.onlyOneActive) {
          el.setItemState(item, false);
        }
      });
    }
  }

  customElements.define("accordion-wrapper", Accordion);
}
